export default {
 CLIENT_SUCCESS(state, data) {
    state.clientList = data;
  },

  CLIENT_FAILURE(state) {
    state.clientList = null;
  },
}